const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export async function getSettings() {
  const [settings, content] = await Promise.all([
    fetch(`${API}/api/settings`).then(r => r.json()),
    fetch(`${API}/api/settings/content`).then(r => r.json()),
  ]);
  return { settings, content };
}

export async function getSlides() {
  const r = await fetch(`${API}/api/slides`);
  return r.json();
}

export async function getDocuments() {
  const r = await fetch(`${API}/api/documents`);
  return r.json();
}

export async function getPartners() {
  const r = await fetch(`${API}/api/partners`);
  return r.json();
}

export async function getContactsInfo() {
  const r = await fetch(`${API}/api/contacts-info`);
  return r.json();
}

export async function getSections() {
  const r = await fetch(`${API}/api/sections`);
  return r.json();
}

export function trackPageview(ref) {
  fetch(`${API}/api/analytics/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type: 'pageview', ref: ref || window.location.pathname }),
  }).catch(() => {});
}

export const UPLOADS_BASE = API;
